/*
 * Copyright (c) 2024-2026. The content provided herein is protected by copyright law. Unauthorized use, reproduction, or distribution of this material without proper licensing, knowledge, and contract agreement from the author is strictly prohibited. Any infringement of these rights may result in legal action. For inquiries regarding the use of this content, please contact the author for proper authorization and agreement.
 */

import {useMemo} from 'react'
import clsx from 'clsx'
import {Timeslot} from 'types/entities/Timeslot'
import UiOfferTimeslotItemsList from './UiOfferTimeslotsGridComponents/UiOfferTimeslotItemsList'
import UiOfferTimeslotSkeletonsList from './UiOfferTimeslotsGridComponents/UiOfferTimeslotSkeletonsList'

type UiOfferTimeslotsGridProps = {
    isLoading: boolean
    timeslots: Timeslot[]
    selectedTimeslot: Timeslot | null
    onSelect: (timeslot: Timeslot) => void
}

const UiOfferTimeslotsGrid = (props: UiOfferTimeslotsGridProps) => {
    const skeletonCount = Math.max(props.timeslots.length, 16)
    const skeletonArray = useMemo(
        () => new Array(skeletonCount).fill(0),
        [skeletonCount]
    )

    return (
        <div
            className={clsx(
                'UiOfferTimeslotsGrid Timeslots flex flex-col w-full h-full flex-grow justify-between text-center select-none relative'
            )}
        >
            <div className={clsx('w-full')}>
                <div className={clsx('relative grow justify-start flex flex-col w-full')}>
                    <div
                        className={clsx(
                            'UiOfferTimeslots relative grid w-full',
                            'grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 xl:grid-cols-6 2xl:grid-cols-6',
                            'gap-2 py-1 px-1 justify-items-stretch items-stretch'
                        )}
                    >
                        {props.isLoading && <UiOfferTimeslotSkeletonsList items={skeletonArray} />}
                        <UiOfferTimeslotItemsList
                            timeslots={props.timeslots}
                            selectedTimeslot={props.selectedTimeslot}
                            onSelect={props.onSelect}
                        />
                    </div>
                </div>
            </div>
        </div>
    )
}

export default UiOfferTimeslotsGrid
